var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 200,
    height: 200,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "rgb(255, 255, 255)"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#0b0001",
    height: 40,
    width: 10,
    y: 30,
    x: 15
  }, /*#__PURE__*/React.createElement("animate", {
    begin: -0.6,
    values: "1;0.2;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    repeatCount: "indefinite",
    dur: "1s",
    attributeName: "opacity"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#c6c6c6",
    height: 40,
    width: 10,
    y: 30,
    x: 35
  }, /*#__PURE__*/React.createElement("animate", {
    begin: -0.4,
    values: "1;0.2;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    repeatCount: "indefinite",
    dur: "1s",
    attributeName: "opacity"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#69ecff",
    height: 40,
    width: 10,
    y: 30,
    x: 55
  }, /*#__PURE__*/React.createElement("animate", {
    begin: -0.2,
    values: "1;0.2;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    repeatCount: "indefinite",
    dur: "1s",
    attributeName: "opacity"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#a7ff0d",
    height: 40,
    width: 10,
    y: 30,
    x: 75
  }, /*#__PURE__*/React.createElement("animate", {
    begin: -1,
    values: "1;0.2;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    repeatCount: "indefinite",
    dur: "1s",
    attributeName: "opacity"
  })), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingSpinner);
export default __webpack_public_path__ + "static/media/loading-spinner.2fbe62c91ce5d77ca33855f59c229adc.svg";
export { ForwardRef as ReactComponent };